import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, IconButton } from '@mui/material';
import Page from '../../layout/Page';
import { DataTable } from '../../components/DataTable';
import ListPageActions from '../../components/ListPageActions';
import DownloadButton from '../../components/DownloadButton';
import CustButton from '../../ui/CustButton';
import DialogConfirm from '../../components/DialogConfirm';
import usePaginationV2 from '../../util/usePaginationV2';

import { Add, Edit, Delete, ImportExport } from '@mui/icons-material';
import SysGlobalKeyservice from '../../service/MasterServices/SysGlobalKeyService';
import SysGlobalKeyCrudDialog from './SysGlobalKeyCrudDialog';
import useGlobal from '../../util/Global';
import NoteDialog from '../../components/NoteDialog';
import DynamicOptions from '../../components/DynamicOptions';
import TruncatedText from '../../components/TruncatedText';
import { text } from '@fortawesome/fontawesome-svg-core';
import { CommonTableAction } from '../../components/CommonCrudColumns';

const SysGlobalKeyPage = ({ title }) => {
    const [selectedItems, setSelectedItems] = useState([]);
    const [deleteItem, setDeleteItem] = useState(null);
    const [loading, setLoading] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [crudTip, setCrudTip] = useState('');
    const { g } = useGlobal();
    const [dialogOpen, setDialogOpen] = useState(false);
    const [globalScript, setGlobalScript] = useState('');
    const [globalData, setGlobalData] = useState([]);


    const handleDeleteAction = async () => {
        if (!deleteItem) return;
        setLoading(true);
        try {
            const result = await SysGlobalKeyservice.delete(deleteItem.id);
            if (result) {
                mainDataList.search();
            }
        } catch (error) {
            console.error('Action failed:', error);
        } finally {
            setLoading(false);
            setOpenDialog(false);
        }
    };



    const columns = [
        {
            name: "groupKey",
            label: g('col.groupKey'),
            textAlign: "left",
            selectOptions: <DynamicOptions serviceType="SysGlobalGroup" />,
            searchType: 'select',
            passItem: true,
            searchField: "sysGlobalGroupId",
            execute: (item) => item.groupKey,
            orderByField: "groupKey",
            cSVColumn: "groupKey"
        },
        {
            name: "keyLabel",
            label: g('col.keyLabel'),
            textAlign: "left"
        },

        {
            name: "trKeyValue",
            label: g('col.trKeyValue'),
            textAlign: "left",
            execute: (item) => TruncatedText({ text: item, maxLength: 50 })
        },
        {
            name: "enKeyValue",
            label: g('col.enKeyValue'),
            textAlign: "left",
            execute: (item) => TruncatedText({ text: item, maxLength: 50 })
        },
        {
            sortable: false,
            searchable: false,
            passItem: true,
            textAlign: 'Center',
            title: 'action',
            execute: (item) => (
                <>
                    <IconButton
                        onClick={() => handleOpenCrudDialog(item, 'Update')}
                        color='warning'
                        variant='contained'
                        title={g('rowActions.update')}
                        size='small'>
                        <Edit />
                    </IconButton>
                    <IconButton
                        onClick={() => openConfirmDialog(item)}
                        color='error'
                        variant='contained'
                        title={g('rowActions.delete')}
                        size='small'>
                        <Delete />
                    </IconButton>
                </>
            ),
        },


    ];

    const mainDataList = usePaginationV2({
        service: SysGlobalKeyservice,
        pageColumns: columns,
        defaultOrderBy: { name: 'Id', type: 'Desc' },
    });

    const actionTable = (CommonTableAction({ service: mainDataList }));

    const [crudItem, setCrudItem] = useState(null);
    const [onCrudDialogOpen, setCrudDialogOpen] = useState(false);

    const handleOpenCrudDialog = (data, tip) => {
        setCrudItem(data);
        setCrudDialogOpen(true);
        setCrudTip(tip);
    };

    const handleClose = async () => {
        setCrudDialogOpen(false);
        await mainDataList.search([]);
    };

    const openConfirmDialog = (item) => {
        setDeleteItem(item);
        setOpenDialog(true);
    };
    const closeConfirmDialog = () => setOpenDialog(false);

    const handelImportScript = () => {
        SysGlobalKeyservice.get().then((res) => {

            if (res.isSuccess) {
                const resultAsJson = JSON.stringify(res.resultObject, null, 2); // Convert to JSON string (pretty-printed)
                setGlobalScript(resultAsJson); // Set the JSON string to state
                setGlobalData(res.resultObject);
                setDialogOpen(true);
            }

        });

    }

    const ActionButtons = () => (
        <ListPageActions
            left={
                <>
                    <CustButton
                        icon={Add}
                        onClick={() => handleOpenCrudDialog(null, 'Create')}
                        style={{ marginLeft: 10 }}
                        disabled={loading}
                    >
                        {title + ' ' + g('button.add')}
                    </CustButton>
                </>
            }

            right={
                <CustButton
                    icon={ImportExport}
                    onClick={handelImportScript}
                    style={{ marginLeft: 10 }}
                    disabled={loading}
                >
                    {g('action.import')}
                </CustButton>
            }

        >
            <DownloadButton service={mainDataList} disabled={loading} />
        </ListPageActions>
    );



    return (
        <Page title={title}>
            <ActionButtons />
            <DataTable
                columns={columns}
                selectAll
                setSelected={setSelectedItems}
                selected={selectedItems}
                {...mainDataList}
                action={actionTable}
            />
            <ActionButtons />
            <SysGlobalKeyCrudDialog
                open={onCrudDialogOpen}
                onClose={handleClose}
                data={crudItem}
                crudTip={crudTip}
                title={title}
            />

            <DialogConfirm
                open={openDialog}
                onClose={closeConfirmDialog}
                onConfirm={handleDeleteAction}
                title={g('title.confirmDialogTitle')}
                content={g('message.areYouSureAction')}
            />

            <NoteDialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                message={globalScript}
                data={globalData}
                title={g('title.Globalization')}
            />
        </Page>
    );
};
export default SysGlobalKeyPage;